module.exports = __webpack_public_path__ + "assets/d6d1698ea7ecf7ab29bf56604186a405.png";